module.exports = __webpack_public_path__ + "static/assets/c9e88af1d675b80aff340cebfce8ecbc.png";